import { LoginForm } from "@/components";
import React from "react";

const Login = () => {
  return (
    <div className="container min-h-[calc(100vh-500px)] flex items-center justify-center mx-auto py-14 px-8 md:px-6 max-w-3xl">
      <LoginForm />
    </div>
  );
};

export default Login;
